import { motion, useReducedMotion } from 'framer-motion';
import type { ReactNode } from 'react';
import { useReportsPrintStaticLayout } from '../hooks/useReportsPrintStaticLayout.hook';

export interface SectionRevealProps {
  children: ReactNode;
  className?: string;
  delay?: number;
}

/**
 * Scroll-reveal wrapper for report sections; renders static children when motion is reduced or on print.
 * @param props - Child content and optional motion delay.
 */
const SectionReveal = ({
  children,
  className = '',
  delay = 0,
}: SectionRevealProps) => {
  const reduceMotion = useReducedMotion();
  const printStatic = useReportsPrintStaticLayout();

  if (reduceMotion || printStatic) {
    return <div className={className}>{children}</div>;
  }

  return (
    <motion.div
      initial={{ opacity: 0, y: 40 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: '-80px' }}
      transition={{ duration: 0.7, delay, ease: [0.22, 1, 0.36, 1] }}
      className={`section-reveal ${className}`.trim()}
    >
      {children}
    </motion.div>
  );
};

export default SectionReveal;
